import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static values = { url: String };

  refresh() {
    const formData = new FormData(this.element);
    formData.delete("_method");

    fetch(this.urlValue, {
      method: "POST",
      body: formData,
      headers: {
        Accept: "text/vnd.turbo-stream.html",
        "X-CSRF-Token": document.querySelector("meta[name='csrf-token']")
          .content,
      },
    })
      .then((response) => response.text())
      .then((html) => window.Turbo.renderStreamMessage(html));
  }
}
